<template>
  <div class="ma-4">
    <v-col cols="12" lg="4" md="4">
    <v-card elevation="0">

        <div><v-text-field v-model="usertrx.ip" label="IP Transaksi"></v-text-field></div>
        <div><v-text-field v-model="usertrx.callback" label="Url Callback/ Report"></v-text-field></div>
        <div><v-text-field readonly v-model="usertrx.apikey" label="API KEY"></v-text-field></div>
        <v-divider/>

      <v-card-actions>
        <v-btn text @click="dosetIP" class="mt-2 primary">SIMPAN</v-btn>
        <v-spacer/>
        <v-btn dark @click="doresetapi" text class="mt-2 blue ml-2">RESET APIKEY</v-btn>
      </v-card-actions>
    </v-card>
    </v-col>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'SettingTrxBeli',
  data: () => ({
  }),
  computed: {
    ...mapState('UserStore', ['usertrx'])
  },
  methods: {
    ...mapActions('UserStore', ['updateProfile', 'getIP', 'setAPI', 'resetAPI']),
    dosetIP () {
      this.$confirm('Yakin Akan Simpan Perubahan?', { color: 'warning', title: 'Konfirmasi', icon: 'fa-question' }).then(res => {
        if (res) {
          this.setAPI(this.usertrx)
        }
      })
    },
    doresetapi () {
      this.$confirm('Yakin akan Reset APIKEY? API KEY dan Secret yang baru akan terkirim ke email anda, APIKEY dan Secret yang lama tidak bisa digun  akan kembali', { color: 'red', title: 'Konfirmasi', icon: 'fa-question' }).then(res => {
        if (res) {
          this.resetAPI()
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
